module.exports = __webpack_public_path__ + "components/flag/static/square/mo-329cd22107baf5913c95bea15e9f99d9.svg";